import { Navigate, useLocation } from 'react-router-dom';
import { RedirectPreserveSearch } from './RedirectPreserveSearch';
import { resolveLegacyRedirect } from './legacyRedirects';

export default function LegacyRedirect() {
  const { pathname, search } = useLocation();
  const target = resolveLegacyRedirect(pathname, search);
  if (!target) return <Navigate to="/categories/all" replace />;
  return <RedirectPreserveSearch to={target} />;
}
